/* sk8 Monster Drops, tema PS2, produto.js.
   Dono: frente 1 (produto). Selecao de variante e preco, "Adicionar a
   sacola" (#botao-sacola: poe na sacola por AJAX e abre a gaveta da sacola,
   SK8.abrirGaveta de gaveta.js), a tabela de medidas interativa (sincronizada
   com o tamanho da compra nos dois sentidos), o navegador de midia ao redor
   do palco (3D + uma miniatura por foto, mostrarMidia troca o que aparece
   dentro do mesmo palco), o motor 3D sob demanda (so baixa quando o palco
   aparece) e a lupa com zoom de pinca, roda do mouse e arrasto. Em celular
   fraco (SK8.leve, decidido no templates/product.liquid antes da primeira
   pintura) a pagina abre na primeira foto e o 3D so baixa no toque em "3D". Carrega so
   em templates/product.liquid, depois de base.js, gaveta.js e de
   maleta.css/maleta.js (usa SK8.som, SK8.$, SK8.$$, SK8.importar,
   SK8.atualizarSacola, SK8.abrirGaveta, SK8.modulos, SK8.rotas). Expoe
   SK8.abrirLupa e SK8.fecharLupa; o Escape e o botao B do controle, tratados
   em base.js, fecham a lupa por aqui. */
(function () {
  "use strict";

  var SK8 = window.SK8 || {};
  var $ = SK8.$, $$ = SK8.$$;
  var Som = SK8.som;
  var importar = SK8.importar;
  var atualizarSacola = SK8.atualizarSacola;
  var dinheiro = function (c) { return "R$ " + (Number(c) / 100).toFixed(2).replace(".", ","); };

  var form = $("#form-compra");
  if (!form) return;
  var dados = $("#dados-variantes"), variantes = [];
  try { variantes = JSON.parse(dados.textContent); } catch (e) {}
  var campo = $("#variante", form), sacola = $("#botao-sacola", form);
  var valor = $("#valor"), selo = $("#desconto"), erro = $("#compra-erro");

  function escolhida() {
    var sel = [];
    $$(".tamanhos", form).forEach(function (g, i) {
      var r = $("input:checked", g);
      sel[i] = r ? r.value : null;
    });
    return variantes.filter(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0];
  }
  function mostrarErro(texto) {
    if (!erro) return;
    erro.textContent = texto || "";
    erro.hidden = !texto;
  }
  function marcarBotao(disponivel) {
    sacola.disabled = !disponivel;
    $(".texto", sacola).textContent = disponivel ? "Adicionar \u00e0 sacola" : "Esgotado";
  }
  /* foto da variante: escolher Oversized mostra a foto da oversized (a midia
     ligada a variante na Shopify). So troca quando a foto muda, entao trocar
     de tamanho dentro da mesma modelagem nao tira a pessoa do 3D. */
  var inicial = variantes.filter(function (x) { return String(x.id) === campo.value; })[0];
  var midiaAtual = inicial && inicial.featured_media ? String(inicial.featured_media.id) : null;
  function fotoDaVariante(v) {
    var id = v.featured_media && String(v.featured_media.id);
    if (!id || id === midiaAtual) return;
    midiaAtual = id;
    var item = $(".midia-item[data-media-id='" + id + "']");
    if (item) mostrarMidia("foto", Number(item.getAttribute("data-indice")));
  }
  form.addEventListener("change", function (e) {
    if (!e.target.matches("input[type=radio]")) return;
    Som.tocar("mover");
    mostrarErro("");
    var v = escolhida();
    if (!v) return;
    campo.value = v.id;
    fotoDaVariante(v);
    var promo = v.compare_at_price > v.price;
    if (valor) valor.innerHTML = (promo ? "<s>" + dinheiro(v.compare_at_price) + "</s>" : "") + dinheiro(v.price);
    if (selo) { selo.hidden = !promo; if (promo) selo.textContent = "-" + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + "%"; }
    marcarBotao(v.available);
    try { history.replaceState(null, "", location.pathname + "?variant=" + v.id); } catch (e2) {}
  });

  /* "Adicionar a sacola": poe na sacola por AJAX e abre a gaveta com a sacola
     atualizada. Sem fetch (ou sem a gaveta), o formulario segue o caminho
     normal da Shopify e cai na pagina /cart. Erro de estoque ou de rede vira
     mensagem embaixo do botao, sem sair da pagina. */
  var ocupado = false;
  form.addEventListener("submit", function (e) {
    if (!window.fetch || !SK8.abrirGaveta) return;
    e.preventDefault();
    if (ocupado || sacola.disabled) return;
    ocupado = true;
    sacola.disabled = true;
    sacola.setAttribute("aria-busy", "true");
    mostrarErro("");
    Som.tocar("confirmar");
    fetch(SK8.rotas.adicionar + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(campo.value), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) { var falha = new Error("sacola"); falha.status = r.status; throw falha; }
      return fetch(SK8.rotas.sacola + ".js", { headers: { Accept: "application/json" } }).then(function (r2) { return r2.json(); });
    }).then(function (c) {
      atualizarSacola(c.item_count);
      Som.tocar("guardar");
      if (SK8.voz) SK8.voz("boa-escolha", true);
      SK8.abrirGaveta(c, sacola);
    }).catch(function (falha) {
      Som.tocar("erro");
      mostrarErro(falha && falha.status === 422
        ? "N\u00e3o h\u00e1 mais unidades deste tamanho em estoque. Escolha outro tamanho."
        : "N\u00e3o foi poss\u00edvel adicionar \u00e0 sacola. Verifique a sua conex\u00e3o e tente novamente.");
    }).then(function () {
      ocupado = false;
      sacola.removeAttribute("aria-busy");
      var v = escolhida() || { available: true };
      marcarBotao(v.available);
    });
  });

  /* tabela de medidas: escolher um tamanho mostra os valores sobre o desenho.
     Fica sincronizada com o tamanho da compra nos dois sentidos: trocar aqui
     marca o tamanho da compra (se estiver disponivel) e trocar la muda aqui. */
  var medidas = $("[data-medidas]"), grupoCompra = $("[data-tamanho-compra]", form);
  var calmo = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function contar(el, alvo) {
    var atual = parseInt(el.textContent, 10);
    clearInterval(el._conta);
    if (calmo || isNaN(atual) || atual === alvo) { el.textContent = alvo + " cm"; return; }
    var passo = atual < alvo ? 1 : -1, pulo = Math.max(1, Math.round(Math.abs(alvo - atual) / 8));
    el._conta = setInterval(function () {
      atual += passo * pulo;
      if ((passo > 0 && atual >= alvo) || (passo < 0 && atual <= alvo)) { atual = alvo; clearInterval(el._conta); }
      el.textContent = atual + " cm";
    }, 28);
  }
  function mostrarMedidas(radio) {
    if (!medidas || !radio) return;
    var t = radio.value;
    ["comp", "larg", "manga"].forEach(function (k) {
      var n = Number(radio.getAttribute("data-" + k));
      $$("[data-valor='" + k + "']", medidas).forEach(function (el) { contar(el, n); });
    });
    $$("[data-valor='tamanho']", medidas).forEach(function (el) { el.textContent = t; });
    $$("[data-coluna]", medidas).forEach(function (c) { c.classList.toggle("ativa", c.getAttribute("data-coluna") === t); });
    var compra = grupoCompra && $$("input", grupoCompra).filter(function (r) { return r.value === t; })[0];
    var esgotado = $("[data-medidas-esgotado]", medidas);
    if (esgotado) esgotado.hidden = !(compra && compra.disabled);
  }
  if (medidas) {
    medidas.addEventListener("change", function (e) {
      var r = e.target;
      if (!r.matches("input[name='medida-tamanho']")) return;
      Som.tocar("mover");
      mostrarMedidas(r);
      var compra = grupoCompra && $$("input", grupoCompra).filter(function (x) { return x.value === r.value; })[0];
      if (compra && !compra.disabled && !compra.checked) {
        compra.checked = true;
        compra.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
    if (grupoCompra) grupoCompra.addEventListener("change", function (e) {
      var r = e.target;
      var alvo = $$("input[name='medida-tamanho']", medidas).filter(function (x) { return x.value === r.value; })[0];
      if (alvo && !alvo.checked) { alvo.checked = true; mostrarMedidas(alvo); }
    });
    // o link "Tabela de medidas" ao lado do tamanho rola ate a tabela (sem JS, a ancora faz o mesmo)
    $$("[data-ir-tabela]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        Som.tocar("confirmar");
        medidas.scrollIntoView({ behavior: calmo ? "auto" : "smooth", block: "start" });
        var marcado = $("input[name='medida-tamanho']:checked", medidas) || $("input[name='medida-tamanho']", medidas);
        if (marcado) marcado.focus({ preventScroll: true });
      });
    });
  }

  /* navegador de midia (3D / fotos), ao redor do palco. O primeiro item e o
     3D; os demais, um por foto. Clicar num item troca o que aparece dentro
     do mesmo palco (mesma caixa, so o conteudo muda) e atualiza a linha de
     estado embaixo. */
  var navItens = $$(".midia-item"), itensFoto = navItens.filter(function (b) { return b.getAttribute("data-midia") === "foto"; });
  var palco3d = $("#palco-3d"), palcoFotos = $("#palco-fotos"), estado = $("#palco-estado");
  var grande = $(".foto-principal img");
  var fotos = itensFoto.map(function (b) { return b.getAttribute("data-grande"); });
  var fotosPalco = itensFoto.map(function (b) { return b.getAttribute("data-palco") || b.getAttribute("data-grande"); });
  var pedidoFoto = 0;
  // o palco nunca fica preto: a miniatura (ja baixada) entra na hora e a foto
  // do palco substitui quando termina de chegar, no tamanho do palco
  // (data-srcset com 600, 900 e 1200 de largura; o navegador escolhe)
  function trocarFoto(indice) {
    if (!grande) return;
    var item = itensFoto[indice], mini = $("img", item), alvo = fotosPalco[indice], vez = ++pedidoFoto;
    var conjunto = item && item.getAttribute("data-srcset");
    // a mesma foto ja carregada fica; a primeira, que nasce "lazy" atras do 3D, ainda passa pela miniatura
    if (grande.getAttribute("data-indice") === String(indice) && grande.complete && grande.naturalWidth) return;
    grande.setAttribute("data-indice", String(indice));
    grande.loading = "eager";
    if (mini && mini.currentSrc) { grande.removeAttribute("srcset"); grande.src = mini.currentSrc; }
    var nova = new Image();
    nova.onload = function () {
      if (vez !== pedidoFoto) return;
      if (conjunto) grande.srcset = conjunto;
      grande.src = alvo;
    };
    if (conjunto) { nova.sizes = grande.getAttribute("sizes") || "100vw"; nova.srcset = conjunto; }
    nova.src = alvo;
  }

  function mostrarMidia(tipo, indice) {
    navItens.forEach(function (b) {
      var ativo = b.getAttribute("data-midia") === "3d" ? tipo === "3d" : tipo === "foto" && Number(b.getAttribute("data-indice")) === indice;
      b.setAttribute("aria-current", String(ativo));
    });
    if (tipo === "3d") {
      if (palco3d) palco3d.hidden = false;
      if (palcoFotos) palcoFotos.hidden = true;
      if (estado) estado.textContent = "3D: arraste para inclinar.";
      carregar3d();
    } else {
      if (palco3d) palco3d.hidden = true;
      if (palcoFotos) palcoFotos.hidden = false;
      trocarFoto(indice);
      SK8._fotoAtual = indice;
      if (estado) estado.textContent = "Foto " + (indice + 1) + " de " + fotos.length + ": toque para ampliar.";
    }
  }
  navItens.forEach(function (b) {
    b.addEventListener("click", function () {
      Som.tocar("confirmar");
      var tipo = b.getAttribute("data-midia");
      mostrarMidia(tipo, tipo === "foto" ? Number(b.getAttribute("data-indice")) : null);
    });
  });
  var principal = $(".foto-principal");
  if (principal) principal.addEventListener("click", function () { abrirLupa(SK8._fotoAtual || 0); });

  // 3D sob demanda: so baixa o motor quando o palco aparece. No celular fraco
  // o palco 3D ja nasce escondido e so carrega no toque em "3D".
  var palco = palco3d, pedido = false;
  function carregar3d() {
    if (pedido || !palco || !SK8.modulos) return;
    pedido = true;
    importar(SK8.modulos.examinar).then(function (m) { return m.montar(palco, { leve: !!SK8.leve }); }).catch(function (err) {
      console.warn("3D indisponivel", err);
      var item3d = $(".midia-item[data-midia='3d']");
      if (item3d) item3d.hidden = true;
      if (fotos.length) mostrarMidia("foto", 0);
    });
  }
  if (palco && !palco.hidden) {
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es, o) { if (es[0].isIntersecting) { carregar3d(); o.disconnect(); } }, { rootMargin: "200px" }).observe(palco);
    else carregar3d();
  }

  /* lupa: foto em tela cheia com zoom de pinça, roda do mouse e arrasto */
  var lupa = $("#lupa");
  if (!fotos.length && grande) fotos = [grande.getAttribute("data-grande") || grande.src];
  var img = lupa && $("img", lupa), est = { s: 1, x: 0, y: 0, s0: 1 }, idx = 0, ponteiros = new Map(), pinca = null;
  function aplicar() { img.style.transform = "translate(" + est.x + "px," + est.y + "px) scale(" + est.s + ")"; }
  function encaixar() {
    var w = img.naturalWidth || 1000, h = img.naturalHeight || 1000;
    est.s0 = est.s = Math.min(innerWidth / w, innerHeight / h);
    est.x = (innerWidth - w * est.s) / 2; est.y = (innerHeight - h * est.s) / 2;
    aplicar();
  }
  function zoom(f, px, py) {
    var ns = Math.min(est.s0 * 6, Math.max(est.s0, est.s * f));
    est.x = px - (px - est.x) * (ns / est.s);
    est.y = py - (py - est.y) * (ns / est.s);
    est.s = ns;
    if (ns === est.s0) return encaixar();
    aplicar();
  }
  function mostrarFoto(n) {
    idx = (n + fotos.length) % fotos.length;
    img.onload = encaixar;
    img.src = fotos[idx];
    if (img.complete) encaixar();
    var c = $("[data-lupa-contagem]", lupa);
    if (c) c.textContent = (idx + 1) + " / " + fotos.length;
  }
  function abrirLupa(n) {
    if (!lupa || !fotos.length) return;
    img.style.left = "0"; img.style.top = "0";
    lupa.hidden = false;
    document.documentElement.style.overflow = "hidden";
    mostrarFoto(n);
    Som.tocar("confirmar");
    var f = $("[data-fechar-lupa]", lupa);
    if (f) f.focus();
  }
  SK8.fecharLupa = function () {
    if (!lupa || lupa.hidden) return;
    lupa.hidden = true;
    document.documentElement.style.overflow = "";
    if (principal) principal.focus({ preventScroll: true });
  };
  SK8.abrirLupa = abrirLupa;
  if (lupa) {
    $$("[data-fechar-lupa]", lupa).forEach(function (b) { b.addEventListener("click", function () { Som.tocar("voltar"); SK8.fecharLupa(); }); });
    $$("[data-lupa-passo]", lupa).forEach(function (b) { b.addEventListener("click", function () { Som.tocar("mover"); mostrarFoto(idx + Number(b.getAttribute("data-lupa-passo"))); }); });
    lupa.addEventListener("wheel", function (e) { e.preventDefault(); zoom(e.deltaY < 0 ? 1.18 : 1 / 1.18, e.clientX, e.clientY); }, { passive: false });
    lupa.addEventListener("dblclick", function (e) { if (est.s > est.s0 * 1.05) encaixar(); else zoom(2.6, e.clientX, e.clientY); });
    lupa.addEventListener("pointerdown", function (e) {
      if (e.target.closest("button")) return;
      lupa.setPointerCapture(e.pointerId);
      ponteiros.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (ponteiros.size === 2) {
        var p = Array.from(ponteiros.values());
        pinca = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) };
      }
    });
    lupa.addEventListener("pointermove", function (e) {
      if (!ponteiros.has(e.pointerId)) return;
      var antes = ponteiros.get(e.pointerId);
      ponteiros.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (ponteiros.size === 2 && pinca) {
        var p = Array.from(ponteiros.values());
        var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        zoom(d / pinca.d, (p[0].x + p[1].x) / 2, (p[0].y + p[1].y) / 2);
        pinca.d = d;
      } else if (ponteiros.size === 1 && est.s > est.s0 * 1.01) {
        est.x += e.clientX - antes.x; est.y += e.clientY - antes.y; aplicar();
      }
    });
    var toque0 = null;
    lupa.addEventListener("pointerup", function (e) {
      var inicio = ponteiros.get(e.pointerId);
      ponteiros.delete(e.pointerId);
      if (ponteiros.size < 2) pinca = null;
      // toque duplo aproxima, igual ao duplo clique
      if (e.pointerType === "touch" && inicio) {
        var agora = Date.now();
        if (toque0 && agora - toque0.t < 300 && Math.hypot(toque0.x - e.clientX, toque0.y - e.clientY) < 30) {
          if (est.s > est.s0 * 1.05) encaixar(); else zoom(2.6, e.clientX, e.clientY);
          toque0 = null;
        } else toque0 = { t: agora, x: e.clientX, y: e.clientY };
      }
    });
    lupa.addEventListener("pointercancel", function (e) { ponteiros.delete(e.pointerId); pinca = null; });
    document.addEventListener("keydown", function (e) {
      if (lupa.hidden) return;
      if (e.key === "ArrowRight") { e.preventDefault(); mostrarFoto(idx + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); mostrarFoto(idx - 1); }
      if (e.key === "+" || e.key === "=") zoom(1.3, innerWidth / 2, innerHeight / 2);
      if (e.key === "-") zoom(1 / 1.3, innerWidth / 2, innerHeight / 2);
    }, true);
    window.addEventListener("resize", function () { if (!lupa.hidden) encaixar(); });
  }

  window.SK8 = SK8;
})();
